import './HistoryVoteCard.css'

import trashIcon from "../../../assets/icons/trash-solid 1.svg"
import deleteBallotPopUp from '../../../assets/icons/delete-ballot-popup.svg'
import strings from '../../../locales/ro.json'
import { useApi } from '../../../hooks/useApi'
import { UserAuth } from '../../../context/AuthContext'
import { useNavigate } from 'react-router-dom'

import { useState, useMemo, useCallback } from 'react'
import StandardPopup from '../../Global/StandardPopup/StandardPopup'

const HistoryVoteCard = ({ title, description, ballotId, closedAt, voters, ballotData }) => {
    const navigate = useNavigate();
    const { user } = UserAuth();
    const { api } = useApi();
    const [openPopUp, setOpenPopUp] = useState(false)

    function onTrashClick(e) {
        e.stopPropagation(); // Prevent card click when clicking trash
        setOpenPopUp(true)
    }

    const handleCardClick = () => {
        navigate(`/ballot/${ballotId}`);
    };

    const deleteBallot = useCallback(async () => {
        try {
            const requests = [api(`ballot/${ballotId}`, "DELETE")];

            if (ballotData?.juniorBallotId) {
                requests.push(api(`ballot/${ballotData.juniorBallotId}`, "DELETE"));
            }

            if (ballotData?.alumniBallotId) {
                requests.push(api(`ballot/${ballotData.alumniBallotId}`, "DELETE"));
            }

            await Promise.all(requests);
            setOpenPopUp(false);
            setTimeout(() => navigate("/"), 500);
        } catch (error) {
            console.error("Error deleting ballot:", error);
            setOpenPopUp(false);
        }
    }, [ballotId, ballotData?.juniorBallotId, ballotData?.alumniBallotId, api, navigate]);

    return (
        <div className='historyVoteCardWrapper' onClick={handleCardClick}>
            <div className="historyVoteCardTitle">{title}</div>
            <div className="historyVoteCardDescription">{description}</div>
            <div className="trashWrapper" onClick={onTrashClick}>
                <img src={trashIcon} className='trashIcon' />
            </div>
            <StandardPopup message={strings.voteHistory.popupTitle} isOpen={openPopUp} yesFcn={deleteBallot} noFcn={() => {setOpenPopUp(false)}} icon={deleteBallotPopUp}/>
        </div>
    )
}

export default HistoryVoteCard